export default __webpack_public_path__ + "static/media/fleek.7481c276.gif";